import React from 'react';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';
import { SvgGroupCenter } from 'apps/sigma2-ui/src/components/svg/SvgGroupCenter';
import { LevelDefinitionIconProps } from 'apps/sigma2-ui/src/components/level-definition-icon-props';

export const PurpleCircleGroup: React.FC<LevelDefinitionIconProps> = (props) => {
  const fillColor = toSvgColor('#A44FB9', props);

  return (
    <g fill="none" {...(props.group ?? {})}>
      <SvgGroupCenter baseWidth={11} baseHeight={12} {...props}>
        <circle cx="5.5" cy="5.60742" r="5.5" fill={fillColor} />
      </SvgGroupCenter>
    </g>
  );
};

export const PurpleCircleSvg: React.FC<LevelDefinitionIconProps> = (props) => {
  return (
    <svg
      width="11"
      height="12"
      viewBox="0 0 11 12"
      xmlns="http://www.w3.org/2000/svg"
      {...(props.svg ?? {})}
    >
      <PurpleCircleGroup {...props} />
    </svg>
  );
};
